// extracted by mini-css-extract-plugin
module.exports = {"author-name":"styles-module__author-name___3gNXc"};